(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1248],{

/***/ 58715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ ImageGalleryBullets; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: src/components/ImageGalleryBullets/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/ImageGalleryBullets/styles.css.ts.vanilla.css","source":"Ll8xeXpycngwMCB7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKICBib3R0b206IDhweDsKICBkaXNwbGF5OiBmbGV4OwogIGxlZnQ6IDUwJTsKICBwb3NpdGlvbjogYWJzb2x1dGU7CiAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC01MCUpOwogIHotaW5kZXg6IDEwOwp9Ci5fMXl6cnJ4MDEgewogIGJhY2tncm91bmQtY29sb3I6ICNGRkZGRkY7CiAgYm9yZGVyLXJhZGl1czogNTAlOwogIGRpc3BsYXk6IGlubGluZS1ibG9jazsKICBoZWlnaHQ6IDA7CiAgbWFyZ2luOiAwOwogIG9wYWNpdHk6IDAuNTsKICB0cmFuc2l0aW9uOiBhbGwgLjNzIGVhc2Utb3V0OwogIHdpZHRoOiAwOwp9Ci5fMXl6cnJ4MDIgewogIGhlaWdodDogNnB4OwogIG1hcmdpbjogMCAzcHg7CiAgd2lkdGg6IDZweDsKfQouXzF5enJyeDAzIHsKICBvcGFjaXR5OiAxOwp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(28000);
// EXTERNAL MODULE: ./node_modules/@vanilla-extract/recipes/createRuntimeFn/dist/vanilla-extract-recipes-createRuntimeFn.esm.js
var vanilla_extract_recipes_createRuntimeFn_esm = __webpack_require__(83331);
;// CONCATENATED MODULE: ./src/components/ImageGalleryBullets/styles.css.ts


var dynamicBullets = (0,vanilla_extract_recipes_createRuntimeFn_esm/* createRuntimeFn */.u)({defaultClassName:'_1yzrrx01',variantClassNames:{isInView:{true:'_1yzrrx02'},isCurrent:{true:'_1yzrrx03'}},defaultVariants:{},compoundVariants:[]});
var imageGalleryBullets = '_1yzrrx00';
;// CONCATENATED MODULE: ./src/components/ImageGalleryBullets/index.tsx



var ImageGalleryBullets = function(param) {
    var currentIndex = param.currentIndex, totalItems = param.totalItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: imageGalleryBullets,
        children: Array.from(Array(totalItems).keys()).map(function(index) {
            var isInView = Math.abs(currentIndex - index) <= 2 || currentIndex <= 1 && index <= 4 || currentIndex >= totalItems - 3 && index >= totalItems - 5;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicBullet, {
                isCurrent: index === currentIndex,
                isInView: isInView
            }, "dynamic-bullet-".concat(index));
        })
    });
};
var DynamicBullet = function(param) {
    var isCurrent = param.isCurrent, isInView = param.isInView;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: dynamicBullets({
            isCurrent: isCurrent,
            isInView: isInView
        })
    });
};


/***/ }),

/***/ 67069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88082);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66731);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var _components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13976);
/* harmony import */ var _context_Cities__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54673);






var ListingDetailLink = function(props) {
    var lang = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().lang;
    var cities = (0,_context_Cities__WEBPACK_IMPORTED_MODULE_5__/* .useCities */ .M1)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        passHref: true,
        href: _components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_4__/* .linkBuilder.listingDetail.url */ .H.listingDetail.url(lang, props.slug),
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ListingDetailLink);


/***/ }),

/***/ 59951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ListingCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(61978);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react-image-gallery/build/image-gallery.js
var image_gallery = __webpack_require__(71572);
var image_gallery_default = /*#__PURE__*/__webpack_require__.n(image_gallery);
// EXTERNAL MODULE: ./src/components/CardCasavoLogo/index.tsx + 1 modules
var CardCasavoLogo = __webpack_require__(45600);
// EXTERNAL MODULE: ./src/components/Link/ListingDetailLink.tsx
var ListingDetailLink = __webpack_require__(67069);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 97 modules
var motion = __webpack_require__(38494);
// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/components/Tooltip/style.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/Tooltip/style.css.ts.vanilla.css","source":"Ll81dzdxcmcwIHsKICAtd2Via2l0LXRhcC1oaWdobGlnaHQtY29sb3I6IHRyYW5zcGFyZW50OwogIHBvc2l0aW9uOiByZWxhdGl2ZTsKfQouXzV3N3FyZzIgewogIGJhY2tncm91bmQtY29sb3I6ICMxRDFEMUI7CiAgYm90dG9tOiBjYWxjKDEwMCUgKyAxNXB4KTsKICBjb2xvcjogI0ZGRkZGRjsKICB3aWR0aDogMTUwcHg7CiAgcG9pbnRlci1ldmVudHM6IG5vbmU7Cn0KLl81dzdxcmczIHsKICBib3JkZXItbGVmdDogMTVweCBzb2xpZCB0cmFuc3BhcmVudDsKICBib3JkZXItcmlnaHQ6IDE1cHggc29saWQgdHJhbnNwYXJlbnQ7CiAgYm9yZGVyLXRvcDogMTVweCBzb2xpZCAjMUQxRDFCOwogIGJvdHRvbTogLTEwcHg7CiAgY29sb3I6ICMxRDFEMUI7CiAgaGVpZ2h0OiAwOwogIGxlZnQ6IDUwJTsKICBwb3NpdGlvbjogYWJzb2x1dGU7CiAgcmlnaHQ6IGF1dG87CiAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC01MCUpOwogIHdpZHRoOiAwOwp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDc2OHB4KSB7CiAgLl81dzdxcmczIHsKICAgIGxlZnQ6IDUwJTsKICAgIHJpZ2h0OiBhdXRvOwogIH0KfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(44170);
;// CONCATENATED MODULE: ./src/components/Tooltip/style.css.ts


var tooltipBox = '_5w7qrg2 tfghjgju tfghjggc tfghjghi tfghjgio _1b5wm20ac tfghjgbx _1b5wm207u tfghjg20 tfghjg29 tfghjgko';
var tooltipTriangle = '_5w7qrg3';
var tooltipWrapper = '_5w7qrg0';
;// CONCATENATED MODULE: ./src/components/Tooltip/index.tsx






var Tooltip = function(param) {
    var children = param.children, text = param.text;
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    var device = (0,Device/* useDevice */.Fy)();
    var tooltipAnimation = {
        hover: {
            opacity: 1,
            transition: {
                opacity: {
                    duration: 0.2
                },
                y: {
                    duration: 0.3
                }
            },
            y: -2
        },
        initial: {
            opacity: 0,
            transition: {
                opacity: {
                    delay: 0.3,
                    duration: 0
                },
                y: {
                    duration: 0.3
                }
            },
            y: 0
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
        animate: isActive ? "hover" : "initial",
        className: tooltipWrapper,
        onClick: function(e) {
            setIsActive(!isActive);
            e.preventDefault();
            e.stopPropagation();
        },
        onHoverEnd: function() {
            return setIsActive(false);
        },
        onHoverStart: function() {
            return setIsActive(true);
        },
        onMouseOutCapture: function() {
            return device === "mobile" && setIsActive(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                className: tooltipBox,
                variants: tooltipAnimation,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        color: "white",
                        children: text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: tooltipTriangle
                    })
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ var components_Tooltip = (Tooltip);

// EXTERNAL MODULE: ./src/context/Cities.tsx
var Cities = __webpack_require__(54673);
// EXTERNAL MODULE: ./src/design-lib/components/Badge/index.tsx + 1 modules
var Badge = __webpack_require__(53964);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/types/listing.ts
var types_listing = __webpack_require__(76362);
// EXTERNAL MODULE: ./src/utils/balcony-counter.ts
var balcony_counter = __webpack_require__(96417);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(41906);
// EXTERNAL MODULE: ./src/utils/floors.tsx
var floors = __webpack_require__(21041);
// EXTERNAL MODULE: ./src/utils/format-listing-sellingPrice.ts
var format_listing_sellingPrice = __webpack_require__(65565);
// EXTERNAL MODULE: ./src/utils/get-translated-title.ts
var get_translated_title = __webpack_require__(22862);
// EXTERNAL MODULE: ./src/utils/isStorageSupported.ts
var isStorageSupported = __webpack_require__(17668);
// EXTERNAL MODULE: ./src/utils/locale-variables/index.ts
var locale_variables = __webpack_require__(98640);
// EXTERNAL MODULE: ./src/utils/new-property.ts
var new_property = __webpack_require__(69854);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: ./src/components/_base/LazyLoadImage/index.tsx
var LazyLoadImage = __webpack_require__(29152);
// EXTERNAL MODULE: ./src/components/FavouriteButton/index.tsx + 1 modules
var FavouriteButton = __webpack_require__(45931);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 21 modules
var Icon = __webpack_require__(81016);
// EXTERNAL MODULE: ./src/components/ImageGalleryBullets/index.tsx + 1 modules
var ImageGalleryBullets = __webpack_require__(58715);
// EXTERNAL MODULE: ./src/components/ListingCard/styles.css.ts
var ListingCard_styles_css = __webpack_require__(96845);
;// CONCATENATED MODULE: ./src/components/ListingCard/index.tsx
/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/anchor-is-valid */ 




























var ListingCard = /*#__PURE__*/ (0,react.memo)(function(param) {
    var dataTestId = param.dataTestId, isLoading = param.isLoading, isOnMap = param.isOnMap, listing = param.listing, onListingCardHover = param.onListingCardHover;
    var ref, ref1, ref2;
    var ref3 = (0,useTranslation/* default */.Z)(), lang = ref3.lang, t = ref3.t;
    var cities = (0,Cities/* useCities */.M1)();
    var device = (0,Device/* useDevice */.Fy)();
    var isIBuyerOrOdaInventory = listing.detail.inventory === types_listing/* CasavoInventory.iBuyer */.M.iBuyer || listing.detail.inventory === types_listing/* CasavoInventory.Agency */.M.Agency;
    (0,react.useEffect)(function() {
        if (isLoading && (0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        }) && sessionStorage.getItem("CASAVO@LISTING-BACK")) {
            setTimeout(function() {
                return sessionStorage.removeItem("CASAVO@LISTING-BACK");
            }, 100);
        }
    }, [
        isLoading
    ]);
    var imageHeight = !isOnMap ? 200 : 170;
    var images = (ref = listing.photos) === null || ref === void 0 ? void 0 : ref.slice(0, 8).map(function(photo) {
        return {
            original: "".concat(photo.url, "?auto=compress,format&fit=crop&").concat(isOnMap ? "ar=1:1" : "ar=2:1", "&h=").concat(isOnMap ? "170" : "400"),
            primary: photo.isPrimary
        };
    });
    var imageGalleryRef = (0,react.useRef)(null);
    var ref4 = (0,react.useState)(0), currentImageIndex = ref4[0], setCurrentImageIndex = ref4[1];
    var listingCity = cities.list.find(function(city) {
        return city.slug === listing.detail.city;
    });
    var isNew = (0,new_property/* checkListingNew */.$6)(listing);
    var hasBeenPublishedInTheLast72Hours = (0,new_property/* checkListingPublishedIn */.PE)(listing.publishedAt, 72);
    var hasBeenVisited = (0,new_property/* checkListingHasBeenVisited */.s6)(listing.id);
    var handlerNavArrowsClick = function(onClick) {
        return function(event) {
            event.preventDefault();
            event.stopPropagation();
            onClick();
        };
    };
    /** argument for getFloor() */ var floorData = {
        buildingFloors: listing.detail.buildingFloors,
        entireBuilding: listing.detail.entireBuilding,
        entranceFloor: listing.detail.entranceFloor,
        floorPosition: listing.detail.floorPosition
    };
    var ref5 = (0,locale_variables/* getRoomDataForLocale */.IP)(lang, listing.characteristics), numberOfRooms = ref5.numberOfRooms, roomLabel = ref5.roomLabel;
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetailLink/* default */.Z, {
        cityValue: listingCity.slug,
        slug: listing.slug,
        zoneSlug: (ref6 = (ref1 = listing === null || listing === void 0 ? void 0 : listing.detail.zone) === null || ref1 === void 0 ? void 0 : ref1.slug) !== null && ref6 !== void 0 ? ref6 : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "data-testid": dataTestId,
            onClick: function() {
                (0,isStorageSupported/* isStorageSupported */.p)(function() {
                    return sessionStorage;
                }) && sessionStorage.setItem("CASAVO@LISTINGS-PAGE-OFFSET", "".concat(window.pageYOffset));
                isOnMap ? (0,eventsHandlers/* handleListingsMapClick */.ND)("ListingCard") : (0,eventsHandlers/* handleListingPageClick */.kN)("ListingCard");
                (0,eventsHandlers/* sendSupportEventWithListingId */.eT)(listing.id, isOnMap ? true : false);
                if (isNew && !isOnMap) (0,eventsHandlers/* handleListingsMapClick */.ND)("NewListingCard");
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,ListingCard_styles_css/* listingCard */.SJ)({
                    isOnMap: isOnMap
                }),
                onMouseEnter: function() {
                    if (device === "desktop" && onListingCardHover) {
                        onListingCardHover(listing.id);
                    }
                },
                onMouseLeave: function() {
                    if (device === "desktop" && onListingCardHover) {
                        onListingCardHover(null);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: isOnMap ? ListingCard_styles_css/* cardImageOnMap */.Gy : ListingCard_styles_css/* cardImage */.qd,
                        children: [
                            listing.contactInfo.ownedByCasavo && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCasavoLogo/* default */.Z, {
                                inventory: listing.detail.inventory,
                                isLabelVisible: !isOnMap
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_gallery_default()), {
                                ref: imageGalleryRef,
                                items: images,
                                renderCustomControls: isOnMap ? null : function() {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGalleryBullets/* ImageGalleryBullets */.B, {
                                        currentIndex: currentImageIndex,
                                        totalItems: listing.photos.slice(0, 8).length
                                    });
                                },
                                renderItem: function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoadImage/* default */.Z, {
                                        height: imageHeight,
                                        src: item.original
                                    });
                                },
                                renderLeftNav: function(onClick) {
                                    return !isOnMap && device === "desktop" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: ListingCard_styles_css/* listingCardCarouselButton.prev */.be.prev,
                                        onClick: handlerNavArrowsClick(onClick)
                                    }) : null;
                                },
                                renderRightNav: function(onClick) {
                                    return !isOnMap && device === "desktop" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: ListingCard_styles_css/* listingCardCarouselButton.next */.be.next,
                                        onClick: handlerNavArrowsClick(onClick)
                                    }) : null;
                                },
                                showBullets: false,
                                showFullscreenButton: false,
                                showPlayButton: false,
                                showThumbnails: false,
                                slideDuration: 300,
                                stopPropagation: true,
                                onSlide: function() {
                                    setCurrentImageIndex(imageGalleryRef.current.getCurrentIndex());
                                    (0,eventsHandlers/* handleClick */.qk)("ListingCard", "ChangeImage");
                                }
                            }),
                            isNew && !isOnMap && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    position: "absolute",
                                    right: "s",
                                    top: "s"
                                }),
                                label: t("common:new_listing_label"),
                                styleVariant: "warning"
                            }),
                            listing.contactInfo.ownedByCasavo && !isOnMap && listing.virtualTours && listing.virtualTours.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    bottom: "m-l",
                                    left: "s",
                                    position: "absolute"
                                }),
                                icon: "VirtualTour",
                                label: t("common:cta_show_virtual_tour"),
                                styleVariant: "greyscale"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: isOnMap ? ListingCard_styles_css/* cardBodyOnMap */.V5 : ListingCard_styles_css/* cardBody */.r,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: ListingCard_styles_css/* cardTitleInfo */.kd,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Caption */.YS, {
                                                className: ListingCard_styles_css/* cardCityArea */.fX,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: listingCity === null || listingCity === void 0 ? void 0 : listingCity.translatedCityName
                                                    }),
                                                    listing.detail.zone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: ListingCard_styles_css/* cardCityAreaDivider */.JS
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                "data-testid": "listing-card-zone",
                                                                children: listing.detail.zone.label
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !isOnMap && hasBeenPublishedInTheLast72Hours && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Small */.x4, {
                                                className: (0,sprinkles_css/* sprinkles */.K)({
                                                    flexShrink: 0,
                                                    marginLeft: "s"
                                                }),
                                                color: hasBeenVisited ? "greyscale500" : "greyscale600",
                                                children: (0,lodash.capitalize)((0,date/* fromNow */.Zh)(listing.publishedAt, lang))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                        strong: true,
                                        className: isOnMap ? ListingCard_styles_css/* listingCardTitle */.PS : styles_css/* paddingBottom.s */.Et.s,
                                        "data-testid": "listing-card-title",
                                        children: (0,get_translated_title/* default */.Z)((ref2 = listing.detail) === null || ref2 === void 0 ? void 0 : ref2.titles, lang)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: ListingCard_styles_css/* cardData */.g2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: ListingCard_styles_css/* cardDataValue */.Mh,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                                        children: listing.detail.commercialArea
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                        children: "m\xb2"
                                                    })
                                                ]
                                            }),
                                            (0,floors/* getFloor */.WL)(floorData, t)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: ListingCard_styles_css/* cardInfoRow */.zo,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                        children: t("common:".concat(roomLabel))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: ListingCard_styles_css/* cardDataValue */.Mh,
                                                        children: [
                                                            numberOfRooms,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Rooms */.Z.Rooms, {
                                                                className: ListingCard_styles_css/* cardInfoIcon */.I8
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                        children: t("common:bathrooms")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: ListingCard_styles_css/* cardDataValue */.Mh,
                                                        children: [
                                                            listing.characteristics.bathrooms,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Bathroom */.Z.Bathroom, {
                                                                className: ListingCard_styles_css/* cardInfoIcon */.I8
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                        children: t("common:status")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: ListingCard_styles_css/* cardDataValue */.Mh,
                                                        children: t("common:".concat(listing.characteristics.stateOfMaintenance.toLowerCase()))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    alignItems: "center",
                                    display: "flex",
                                    flexWrap: {
                                        desktop: "nowrap",
                                        mobile: "wrap",
                                        tablet: "wrap"
                                    },
                                    justifyContent: "space-between"
                                }),
                                children: [
                                    (balcony_counter/* default.get */.Z.get(listing.characteristics.terraces) > 0 || listing.services.garden) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            flexBasis: {
                                                desktop: "unset",
                                                mobile: "100%",
                                                tablet: "100%"
                                            }
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Tooltip, {
                                            text: t("common:tooltips.outdoor_space"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                className: (0,sprinkles_css/* sprinkles */.K)({
                                                    marginRight: "xs",
                                                    maxWidth: "100%"
                                                }),
                                                icon: "Tree",
                                                label: !isOnMap && t("common:outdoor_space_label"),
                                                styleVariant: "greyscale"
                                            })
                                        })
                                    }),
                                    (listing.detail.sellingPrices || listing.detail.privateNegotiation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            alignItems: "center",
                                            display: "flex",
                                            flexGrow: {
                                                desktop: 0,
                                                mobile: 1,
                                                tablet: 1
                                            },
                                            gap: "s-m",
                                            marginLeft: "auto"
                                        }),
                                        children: [
                                            isIBuyerOrOdaInventory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Check */.Z.Check, {
                                                className: index_es/* colorVariants.orange600 */.Jj.orange600
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                                color: "greyscale600",
                                                children: (0,format_listing_sellingPrice/* formatListingSellingPrice */.F)(listing.detail.privateNegotiation, listing.detail.sellingPrices, t, lang)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FavouriteButton/* FavouriteButton */.A, {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            padding: "s"
                                        }),
                                        //TODO: replace with a real value
                                        gtmTouchpoint: "ListingCard",
                                        id: listing.id,
                                        isFavouriteInitialValue: false
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
});
ListingCard.displayName = "ListingCard";
/* harmony default export */ var components_ListingCard = (ListingCard);


/***/ }),

/***/ 59082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ListingCardMapMobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react-image-gallery/build/image-gallery.js
var image_gallery = __webpack_require__(71572);
var image_gallery_default = /*#__PURE__*/__webpack_require__.n(image_gallery);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(48489);
// EXTERNAL MODULE: ./src/components/Link/ListingDetailLink.tsx
var ListingDetailLink = __webpack_require__(67069);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/shared-styles/common-variables.tsx
var common_variables = __webpack_require__(38730);
// EXTERNAL MODULE: ./src/utils/format-currency.ts
var format_currency = __webpack_require__(58577);
// EXTERNAL MODULE: ./src/utils/get-translated-title.ts
var get_translated_title = __webpack_require__(22862);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 21 modules
var Icon = __webpack_require__(81016);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/components/ListingCardMapMobile/style.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/ListingCardMapMobile/style.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA61V0W6bMBR9z1dcaaqUaHWEk9Cm7ss0VfuHPU0GX4JbYzPbKWmn/vsEmMSktNWqIR6se+17zz3nYJa/brY6/31P4c8MoJKaNFL4kkGa1IfbGUDNhZB6R7ypGSRthCu500R6rByDHLVH24Zzo4xl8IXe0Tv6vY0I6WrFnxgUCrtahdGeOPmMDOimLf8yW4b+q67/6xMKDwwoJH1r84i2UKZhUEohULcxjwdPTglUStZOujbVlNIjcTXPkYE2jeV13HPd9cx4/rCzZq9FBA1o2o8fZYcBf3TPWbI2Tnpp9MBIREy0y2KN3LdYwrLLGyvQksx4bypi5a70xHIh944BDSqEPd7URGFxym/6dIntKQbrsL3dE9Q6AeOZM2rvsSPtqGaQe33Vn3wmUouO85iptGMqbKVJMtbuusuSBrMH6UlmDsRYidozeETrZc7VbZRXUiPJFa9qBusPjBPV/IT8r+wWQk1gKzNKdGy1iAYK6XIVz7Y998iEC3ptziR5y8rDkghpMQ+WMWpfddPc752XxRPJjfYdg515SYa+wX7e8D0yoEGxkyoXMfCbj4Hne+vaUG3k4NVJ1DFUa5rYcMELABW3O6mDicfWilHxHtWYse3g8QNxJRetjAkkkNYHSMDuMj5PLiG8y3QR18tYIa3zxBTEP9XYX2IdlLYGbSkB8JZrVxhbsX6puMef85vVxVkpxScrHYfajm2ff7433W7GzXOmfTlUmq8WU+2T+IAY35eZMvnDhA6B2mkUyeKYG64IpWCZOkDuMO6GI3h0cQnTmTHw6BYKEdu7Jnkf06lv8WH19OJ1+fQfVC/eVP1/o9fwFTaLsWza6BHP5ZTudNX77luFQnJwuUXUwLWAefS/vr7a1oe+/PifOtw8t8f1xPf8Mnv5C5DqlPkKCAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(89352);
// EXTERNAL MODULE: ./node_modules/@vanilla-extract/recipes/createRuntimeFn/dist/vanilla-extract-recipes-createRuntimeFn.esm.js
var vanilla_extract_recipes_createRuntimeFn_esm = __webpack_require__(83331);
;// CONCATENATED MODULE: ./src/components/ListingCardMapMobile/style.css.ts



var cardBody = '_98ncqj8';
var cardCasavoLogo = '_98ncqj3';
var cardData = '_98ncqj2';
var cardDataValue = '_98ncqj1 tfghjgdu tfghjgk9';
var cardGrid = (0,vanilla_extract_recipes_createRuntimeFn_esm/* createRuntimeFn */.u)({defaultClassName:'_98ncqj9',variantClassNames:{isOnDetail:{false:'_98ncqja'}},defaultVariants:{},compoundVariants:[]});
var cardImage = '_98ncqj5 _1b5wm207r tfghjg2c';
var cardLink = (0,vanilla_extract_recipes_createRuntimeFn_esm/* createRuntimeFn */.u)({defaultClassName:'_98ncqjd',variantClassNames:{isAggregateListOpen:{true:'_98ncqje',false:'_98ncqjf'},aggregateLengthLessThan3:{true:'_98ncqjg'},isOnDetail:{true:'_98ncqjh'}},defaultVariants:{},compoundVariants:[[{aggregateLengthLessThan3:true,isAggregateListOpen:false},'_98ncqjb'],[{aggregateLengthLessThan3:false,isAggregateListOpen:false},'_98ncqjc']]});
var cardTitle = '_98ncqj7 tfghjgbl';
;// CONCATENATED MODULE: ./src/components/ListingCardMapMobile/index.tsx
/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/anchor-is-valid */ 














var ListingCardMapMobile = /*#__PURE__*/ react.memo(function(param) {
    var aggregateLength = param.aggregateLength, dataTestId = param.dataTestId, isAggregateListOpen = param.isAggregateListOpen, _isOnDetail = param.isOnDetail, isOnDetail = _isOnDetail === void 0 ? false : _isOnDetail, property = param.property;
    var ref, ref1, ref2, ref3;
    var lang = (0,useTranslation/* default */.Z)().lang;
    var imageHeight = 100;
    var images = property.photos.slice(0, 8).map(function(photo) {
        return {
            original: "".concat(photo.url, "?auto=compress,format&fit=crop&ar=1:1&h=").concat(imageHeight),
            primary: photo.isPrimary
        };
    });
    var ref4 = config_default()(), casavoUiCdn = ref4.publicRuntimeConfig.casavoUiCdn;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetailLink/* default */.Z, {
        cityValue: property.detail.city,
        slug: property.slug,
        zoneSlug: (ref = property.detail.zone) === null || ref === void 0 ? void 0 : ref.slug,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: cardLink({
                aggregateLengthLessThan3: aggregateLength < 3,
                isAggregateListOpen: isAggregateListOpen,
                isOnDetail: isOnDetail
            }),
            "data-testid": dataTestId,
            onClick: function() {
                (0,eventsHandlers/* handleListingsMapClick */.ND)("ListingCard");
                (0,eventsHandlers/* sendSupportEventWithListingId */.eT)(property.id, true);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cardGrid({
                    isOnDetail: isOnDetail
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cardImage,
                        children: [
                            ((ref1 = property.contactInfo) === null || ref1 === void 0 ? void 0 : ref1.ownedByCasavo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: cardCasavoLogo,
                                style: {
                                    backgroundImage: "url(".concat(casavoUiCdn, "/logo/main-symbol-black.svg)")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_gallery_default()), {
                                disableKeyDown: true,
                                items: images,
                                renderItem: function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                        height: imageHeight,
                                        src: item.original,
                                        style: {
                                            borderBottomLeftRadius: common_variables/* xsRadius */.SF,
                                            borderTopLeftRadius: common_variables/* xsRadius */.SF,
                                            height: imageHeight
                                        },
                                        visibleByDefault: false,
                                        width: "100%"
                                    });
                                },
                                renderLeftNav: function() {
                                    return null;
                                },
                                renderRightNav: function() {
                                    return null;
                                },
                                showBullets: false,
                                showFullscreenButton: false,
                                showPlayButton: false,
                                showThumbnails: false,
                                slideDuration: 450
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cardBody,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: cardTitle,
                                children: (0,get_translated_title/* default */.Z)((ref2 = property.detail) === null || ref2 === void 0 ? void 0 : ref2.titles, lang)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: cardData,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: cardDataValue,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                                        marginRight: "m"
                                                    }),
                                                    children: property.detail.commercialArea
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                    as: "span",
                                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                                        marginLeft: "xs"
                                                    }),
                                                    color: "greyscale500",
                                                    children: "m\xb2"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            alignItems: "center",
                                            display: "flex",
                                            gap: "s"
                                        }),
                                        children: [
                                            ((ref3 = property.contactInfo) === null || ref3 === void 0 ? void 0 : ref3.ownedByCasavo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Check */.Z.Check, {
                                                "aria-hidden": "true",
                                                className: index_es/* colorVariants.orange600 */.Jj.orange600
                                            }),
                                            property.detail.sellingPrices && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                                strong: true,
                                                children: (0,format_currency/* formatPrice */.T)(property.detail.sellingPrices, lang)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
});
ListingCardMapMobile.displayName = "ListingCardMapMobile";
/* harmony default export */ var components_ListingCardMapMobile = (ListingCardMapMobile);


/***/ }),

/***/ 88057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: src/shared-styles/vanilla-keyframes.css.tsx.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/shared-styles/vanilla-keyframes.css.tsx.vanilla.css","source":"QGtleWZyYW1lcyB4aTg3aWwwIHsKICAwJSB7CiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCk7CiAgfQogIDUwJSB7CiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoNXB4KTsKICB9CiAgMTAwJSB7CiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCk7CiAgfQp9CkBrZXlmcmFtZXMgeGk4N2lsMSB7CiAgMCUgewogICAgYmFja2dyb3VuZC1wb3NpdGlvbjogLTIwMHB4IDA7CiAgfQogIDEwMCUgewogICAgYmFja2dyb3VuZC1wb3NpdGlvbjogY2FsYygyMDBweCArIDEwMCUpIDA7CiAgfQp9CkBrZXlmcmFtZXMgeGk4N2lsMiB7CiAgMCUgewogICAgdHJhbnNmb3JtOiByb3RhdGUoM2RlZyk7CiAgfQogIDUwJSB7CiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgtM2RlZyk7CiAgfQogIDEwMCUgewogICAgdHJhbnNmb3JtOiByb3RhdGUoM2RlZyk7CiAgfQp9CkBrZXlmcmFtZXMgeGk4N2lsMyB7CiAgMCUgewogICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7CiAgfQogIDEwMCUgewogICAgdHJhbnNmb3JtOiByb3RhdGUoMzYwZGVnKTsKICB9Cn0KQGtleWZyYW1lcyB4aTg3aWw0IHsKICAwJSB7CiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTUwJSkgcm90YXRlKDQ1ZGVnKTsKICB9CiAgMTAwJSB7CiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoNTAwJSkgcm90YXRlKDQ1ZGVnKTsKICB9Cn0KQGtleWZyYW1lcyB4aTg3aWw1IHsKICBmcm9tIHsKICAgIHdpZHRoOiAwOwogIH0KICB0byB7CiAgICB3aWR0aDogMTAwJTsKICB9Cn0KQGtleWZyYW1lcyB4aTg3aWw2IHsKICA1MCUgewogICAgYm9yZGVyLWNvbG9yOiAjMUQxRDFCOwogIH0KICBmcm9tIHsKICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7CiAgfQogIHRvIHsKICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7CiAgfQp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(60786);
// EXTERNAL MODULE: src/components/Skeleton/index.css.tsx.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/Skeleton/index.css.tsx.vanilla.css","source":"LnJoZjhibDAgewogIGFuaW1hdGlvbjogeGk4N2lsMSAxLjJzIGVhc2UgaW5maW5pdGU7CiAgYmFja2dyb3VuZC1jb2xvcjogI0U4RThFODsKICBiYWNrZ3JvdW5kLWltYWdlOiBsaW5lYXItZ3JhZGllbnQoIHRvIHJpZ2h0LCNFOEU4RTgsI0Y1RjVGNSwjRThFOEU4ICk7CiAgYmFja2dyb3VuZC1yZXBlYXQ6IG5vLXJlcGVhdDsKICBiYWNrZ3JvdW5kLXNpemU6IDIwMHB4IDEwMCU7CiAgaGVpZ2h0OiAxMDBweDsKICB3aWR0aDogMTAwJTsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(20501);
;// CONCATENATED MODULE: ./src/components/Skeleton/index.css.tsx


var skeletonStyle = 'rhf8bl0';
;// CONCATENATED MODULE: ./src/components/Skeleton/index.tsx



var Skeleton = function(param) {
    var className = param.className, height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(skeletonStyle, className),
        style: {
            height: height,
            width: width
        }
    });
};


/***/ }),

/***/ 29152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3292);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48489);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88057);
/* harmony import */ var _design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20579);







var LazyLoadImageSkeleton = function(_param) {
    var alt = _param.alt, height = _param.height, onLoadingEnd = _param.onLoadingEnd, onLoadingStart = _param.onLoadingStart, src = _param.src, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "alt",
        "height",
        "onLoadingEnd",
        "onLoadingStart",
        "src"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isImageLoaded = ref[0], setIsImageLoaded = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !isImageLoaded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
                className: (0,_design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_4__/* .sprinkles */ .K)({
                    bottom: 0,
                    left: 0,
                    position: "absolute",
                    right: 0,
                    top: 0
                }),
                height: height
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__.LazyLoadImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                afterLoad: function() {
                    setIsImageLoaded(true);
                    onLoadingEnd && onLoadingEnd();
                },
                alt: alt,
                beforeLoad: function() {
                    setIsImageLoaded(false);
                    onLoadingStart && onLoadingStart();
                },
                effect: "blur",
                height: height,
                src: src,
                style: {
                    height: height
                },
                width: "100%"
            }, props))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyLoadImageSkeleton);


/***/ }),

/***/ 41906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zh": function() { return /* binding */ fromNow; },
/* harmony export */   "k1": function() { return /* binding */ locales; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63847);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_locale_es__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33238);
/* harmony import */ var dayjs_locale_es__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_es__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_locale_fr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8803);
/* harmony import */ var dayjs_locale_fr__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_fr__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_locale_it__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69395);
/* harmony import */ var dayjs_locale_it__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_it__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_locale_pt__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87392);
/* harmony import */ var dayjs_locale_pt__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_pt__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75706);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5__);
// Dayjs






dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5___default()));
var utc = __webpack_require__(36947);
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend(utc);
var locales = {
    en: "en-GB",
    fr: "fr-FR",
    it: "it-IT"
};
var formatDate = function(format, locale, d) {
    var options = format === "short" ? {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    } : {
        day: "numeric",
        month: "long",
        year: "numeric"
    };
    return new Date(d).toLocaleDateString(locales[locale], options);
};
/**
 * Returns the string of relative time from now in the given Locale.
 * @param {string} date The date to calculate distance in time to.
 * @param {Locale} lang The language to return the relative time in.
 * @returns
 */ var fromNow = function(date, lang) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default().utc(date).locale(lang).fromNow();
};


/***/ }),

/***/ 28000:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 89352:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 20501:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 44170:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);